package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.delete_product_set


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("setProductSets")
    val setProductSets: SetProductSets?,
    @SerialName("__typename")
    val typename: String?
)